import { withStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import React, { Component } from 'react';

interface TnBackButtonProps {
  classes?: any;
  onClick?: any;
}

class TnBackButton extends Component<TnBackButtonProps, any> {
  render():
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | string
    | number
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {
    const { classes, onClick } = this.props;

    return (
      <div
        className={classes.chevronBackButton}
        aria-label="back button"
        onClick={() => {
          if (onClick) {
            onClick();
          } else {
            window.history.back();
          }
        }}
        data-testid={'back_button'}
      >
        <ChevronLeftIcon />
      </div>
    );
  }
}

export default withStyles((theme) => ({
  chevronBackButton: {
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '3px',
    border: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      cursor: 'pointer',
    },
    '& svg': {
      width: '',
      fill: '#526173',
    },
  },
}))(TnBackButton);
